import { ChartingOptions } from "components/charting/types/ChartingOptions.types";
import { createContext } from "react";

const ChartOptionsContext = createContext<ChartingOptions | undefined>(undefined);

export default ChartOptionsContext;
